export const EMPLOYEES_COUNT_KEYS = ['level1', 'level2', 'level3', 'level4'] as const;
type EmployeesCountKey = typeof EMPLOYEES_COUNT_KEYS[number];

export interface EmployeeCounts extends Partial<Record<EmployeesCountKey, number | null>> {
  level1?: number | null;
  level2?: number | null;
  level3?: number | null;
  level4?: number | null;
}
